
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const CoreValues_Slice = createAsyncThunk(
  "data/corevalues",
  async (token) => {
    const res = await fetch(
      `${process.env.REACT_APP_COMPANY_SERVICE_API}/company/core-values`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-API-Key": token,
        },
      }
    );
    const data = await res.json();
    return data;
  }
);

const FetchCoreValues = createSlice({
  name: "corevalues_slice",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(CoreValues_Slice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CoreValues_Slice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(CoreValues_Slice.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default FetchCoreValues.reducer;


 